export enum TransactionDirection {
  Credit = "credit",
  Debit = "debit",
}
